import { createReducer } from '@reduxjs/toolkit'
import { DictT, TagT } from 'types/model'
import { clear, logout, receiveTags } from 'model/actions'

const initialState = {} as DictT<TagT>

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveTags, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
